import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { GsaBondDoc, gsaDefaults, GSA_CSS } from "@/pages/GsaBondPackage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public, token-signed print route for the standalone Bond Claim form (headless-Chrome PDF / eFax).
export default function PrintGsaClaim() {
  const { appId } = useParams();
  const t = new URLSearchParams(useLocation().search).get("t");
  const [app, setApp] = useState(null);
  const [shared, setShared] = useState(null);

  useEffect(() => {
    if (!appId || !t) return;
    (async () => {
      try {
        const r = await axios.get(`${API}/borrower/applications/${appId}/public?t=${encodeURIComponent(t)}`);
        const a = r.data.application || {};
        const saved = a.gsa_bond_settings || {};
        setShared({ ...gsaDefaults(), ...saved });
        setApp(a);
      } catch { /* leave blank */ }
    })();
  }, [appId, t]);

  if (!app || !shared) return <div style={{ padding: 40, fontFamily: "serif" }}>Loading…</div>;
  return (
    <div style={{ background: "#fff" }}>
      <div className="cm-print-area">
        <GsaBondDoc app={app} shared={shared} last claimOnly />
      </div>
      <style>{GSA_CSS}</style>
    </div>
  );
}
